'use client';

import { useEffect } from 'react';
import { useParams } from 'next/navigation';

import { publicConfig } from '../../utils/config';
import { useApplicationStore } from '../../stores/application.store';
import { getSession } from '../../actions/session.actions';

export default function BrazeSession({ userId }: { userId?: string }) {
  const { APP_COUNTRY } = publicConfig();
  const { isBrazeInitialized } = useApplicationStore((state) => state);
  const { lng } = useParams();
  useEffect(() => {
    if (!isBrazeInitialized || !userId) return;
    void (async () => {
      const braze = await import('@braze/web-sdk');
      const session = await getSession();
      const currentUser = braze.getUser()?.getUserId();
      if (currentUser !== userId) braze.changeUser(userId);
      braze.openSession();

      const user = braze.getUser();
      user?.setCountry(APP_COUNTRY ?? null);
      user?.setLanguage(lng as string);
      user?.setPhoneNumber(session?.phoneNumber ?? null);
    })();
  }, [isBrazeInitialized, userId, lng]);

  return null;
}
